import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import { InfoPopupDispatcher } from '../../../_constants/info_popup';

function InfoPopupBody(props) {
  const isUpperImagePathDefined = props.bodyUpperImagePath.length > 0;
  const isLowerImagePathDefined = props.bodyLowerImagePath.length > 0;
  const upperImagePath = props.staticUrl + props.bodyUpperImagePath;
  const lowerImagePath = props.staticUrl + props.bodyLowerImagePath;

  return (
    <section className="info-popup-info-layer info-popup-section">
      {isUpperImagePathDefined && <img className="img-responsive" alt="" src={upperImagePath} />}

      <div className="info-popup-info-layer__note">
        {props.bodyContent.map(function (body, i) {
          return <div key={i} dangerouslySetInnerHTML={toDangerousReactHtml(body)} />;
        })}
      </div>

      {isLowerImagePathDefined && <img className="img-responsive" alt="" src={lowerImagePath} />}

      <button
        className="info-popup-info-layer__continue"
        onClick={props.bodyButtonOnClick}
        style={props.dispatcher === InfoPopupDispatcher.BUY_4_PAY_3 ? { marginTop: '30px' } : {}}
      >
        {props.bodyButtonText}
      </button>
    </section>
  );
}

InfoPopupBody.propTypes = {
  staticUrl: PropTypes.string.isRequired,
  bodyContent: PropTypes.array.isRequired,
  bodyButtonText: PropTypes.string.isRequired,
  bodyButtonOnClick: PropTypes.func.isRequired,
  bodyUpperImagePath: PropTypes.string,
  bodyLowerImagePath: PropTypes.string,
};

InfoPopupBody.defaultProps = {
  bodyUpperImagePath: '',
  bodyLowerImagePath: '',
  bodyContent: [],
};

export { InfoPopupBody };
